import React, { useState, useEffect } from "react";
import usflag from "../../assets/images/usflag.png";

const NotificationCarouselFaceShape = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDropping, setIsDropping] = useState(false);

  const womenNames = [
    "Emma",
    "Olivia",
    "Ava",
    "Isabella",
    "Sophia",
    "Charlotte",
    "Mia",
    "Amelia",
    "Harper",
    "Evelyn",
    "Abigail",
    "Emily",
    "Elizabeth",
    "Mila",
    "Ella",
    "Avery",
    "Sofia",
    "Camila",
    "Aria",
    "Scarlett",
    "Victoria",
    "Madison",
    "Luna",
    "Grace",
    "Chloe",
    "Penelope",
    "Layla",
    "Riley",
    "Zoey",
    "Nora",
    "Lily",
    "Eleanor",
    "Hannah",
    "Lillian",
    "Addison",
    "Aubrey",
    "Ellie",
    "Stella",
    "Natalie",
    "Zoe",
  ];

  // Face shape values
  const faceShapeValues = [
    "Oval",
    "Round",
    "Square",
    "Heart",
    "Diamond",
    "Rectangle",
    "Oblong",
    "Triangle",
    "Pear",
    "Inverted Triangle",
  ];

  const generateNotifications = () => {
    const notifications = [];
    for (let i = 0; i < 20; i++) {
      const randomName =
        womenNames[Math.floor(Math.random() * womenNames.length)];
      const randomFaceShape =
        faceShapeValues[Math.floor(Math.random() * faceShapeValues.length)];

      notifications.push({
        id: i,
        name: randomName,
        faceShape: randomFaceShape,
      });
    }
    return notifications;
  };

  const [notifications] = useState(generateNotifications());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible(false);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % notifications.length);
        setIsDropping(true);
        setIsVisible(true);

        setTimeout(() => {
          setIsDropping(false);
        }, 500);
      }, 300);
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [notifications.length]);

  const currentNotification = notifications[currentIndex];

  return (
    <div className="py-2 w-full overflow-hidden">
      <div className="flex items-center justify-center">
        <div
          className={`flex items-center transition-all duration-500 ease-in-out ${
            isVisible
              ? isDropping
                ? "opacity-100 transform translate-y-0 animate-bounce"
                : "opacity-100 transform translate-y-0"
              : "opacity-0 transform -translate-y-4"
          }`}
        >
          <div className="text-xs text-[#6F665D] flex items-center font-[var(--funnel-cs-font-body)] whitespace-nowrap">
            <span className="font-semibold text-[#9A2E1A]">
              {currentNotification.name}
            </span>
            <span className="mx-1 text-[#6F665D]">Just got her Face Shape Guide!</span>
            <img
              src={usflag}
              alt="US Flag"
              className="w-4 h-3 mx-1 rounded-sm object-cover shadow-sm"
            />
            <span className="text-[#6F665D] mr-1">Matched as</span>
            <span className="font-bold text-[#9A2E1A] bg-[#F3E2DB] px-1 py-0.5 rounded text-xs">
              {currentNotification.faceShape}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCarouselFaceShape;
